import React, { useEffect } from 'react';
import Echo from 'laravel-echo';
import io from 'socket.io-client';
import {url} from "../../utils/variables";
const echo = new Echo({
    host: `${url}:6001`,
    broadcaster: 'socket.io',
    client: io,
});

export default function EventBus({ onEvent }) {

    useEffect(() => {
        const channel = echo.channel('my-channel');
        channel.listen('.my-event', data => {
            // console.log(data)
            onEvent(data);
        });
        return function cleanup() {
            echo.leave('my-channel');
        };
    }, [onEvent])

    return <></>;

}
